
export const AepsType = {


    //aeps details


    selectedRechargableAmnt3: 'selectedRechargableAmnt3',
    setMoneyTransferTotalAmount3: 'setMoneyTransferTotalAmount3',
    setMoneyTransferSurChargeAmount3: 'setMoneyTransferSurChargeAmount3',
    showCreateOrderResponse3: 'showCreateOrderResponse3',
    setOrderId3: 'setOrderId3',
    setAmount3: 'setAmount3',
    setAepsOperator: 'setAepsOperator',
    setAepsMobile: 'setAepsMobile',
    setAepsOptional: 'setAepsOptional',

    setAepsTxnHistory: 'setAepsTxnHistory',
    setTxnAmount3: 'setTxnAmount3',
    setTxnsurcharge3: 'setTxnsurcharge3',
    setTxntotalAmoun3: 'setTxntotalAmoun3',
    setMoneyTransferProgress3: 'setMoneyTransferProgress3',
    setStatusEnqResponse3: 'setStatusEnqResponse3',

    setCreateOrderRes3: 'setCreateOrderRes3',
    setCreteOrderReq3: 'setCreteOrderReq3',
    setStatusEnqResponse3: 'setStatusEnqResponse3',
    setAepsTxnHistory: 'setAepsTxnHistory',

    //biometry
    setBiometricDta: 'setBiometricDta',
    setBiometricDtaCaptureStatus: 'setBiometricDtaCaptureStatus',


    //aeps pricing
    setAepsAmount: 'setAepsAmount',

    //aeps default page
    setAepsSection: 'setAepsSection',
    checkingDriverStatus: 'checkingDriverStatus',

    setCaptureUrl: 'setCaptureUrl',
    setDeviceInfoUrl: 'setDeviceInfoUrl',


    setAepsResponse: 'setAepsResponse',
    setAepsRequest: 'setAepsRequest',
    storeAepsReqBeforeBalanceEnuiry: 'storeAepsReqBeforeBalanceEnuiry',

    setSelectedBankName: 'setSelectedBankName',
    setFullName: 'setFullName',
    setAadhaar: 'setAadhaar',
    setMobile: 'setMobile',

    setCurrentTimeStamp: 'setCurrentTimeStamp',
    setFilterStartDate: 'setFilterStartDate',
    setFilterEndDate: 'setFilterEndDate',

    setReadyDeviceName: 'setReadyDeviceName',
    setAepsCashWithDrwalReq: 'setAepsCashWithDrwalReq',

    setMoneyTransferProgress: 'setMoneyTransferProgress',

    setPayTMAepsSection: 'setPayTMAepsSection',
    storeAepsMerchantInfo: 'storeAepsMerchantInfo',
    setMerchantAuthId: 'setMerchantAuthId',
    setMerchantAuthIdPayTM:'setMerchantAuthIdPayTM',


    RESET: "RESET"
};